import { MapLinkServices } from './accessors';
import type { GeoPoint } from '../realtime/contracts';

function formatDecimalInvariant(value: number): string {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 5,
    maximumFractionDigits: 5,
  }).format(value);
}

function urlFormatCoordinates(coordinates: GeoPoint, separator: string, invert = false): string {
  if (invert) {
    return `${formatDecimalInvariant(coordinates.longitude)}${separator}${formatDecimalInvariant(coordinates.latitude)}`;
  }
  return `${formatDecimalInvariant(coordinates.latitude)}${separator}${formatDecimalInvariant(coordinates.longitude)}`;
}

export function mapLinkUrl(service: MapLinkServices, coordinates: GeoPoint): string {
  switch (service) {
    case MapLinkServices.MapyCz:
      return `https://mapy.cz/turisticka?z=17&x=${urlFormatCoordinates(coordinates, '&y=', true)}&source=coor&id=${urlFormatCoordinates(coordinates, ',', true)}`;
    case MapLinkServices.GoogleMaps:
      return `https://www.google.com/maps/place/${urlFormatCoordinates(coordinates, ',')}/${urlFormatCoordinates(coordinates, ',')},17z`;
    case MapLinkServices.AirNavPro:
      return `airnavpro://direct-to?coordinates=wgs84-decimal&location=${urlFormatCoordinates(coordinates, '_')}`;
    default:
      throw new Error(`MapLinkServices ${String(service)} is not supported!`);
  }
}

export function mapLinkServiceName(service: MapLinkServices): string {
  switch (service) {
    case MapLinkServices.MapyCz:
      return 'Mapy.cz';
    case MapLinkServices.GoogleMaps:
      return 'Google Maps';
    case MapLinkServices.AirNavPro:
      return 'Air Navigation Pro';
    default:
      throw new Error(`MapLinkServices ${String(service)} is not supported!`);
  }
}
